import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import coupon from "./modules/coupon";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    coupon,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});
